export const init = () => {
	const modals = document.querySelectorAll('.js-modal-alt');
	if (!modals) {
		return;
	}
	const modalLinks = document.querySelectorAll('.js-modal-alt-open');
	const closeBtn = document.querySelectorAll('.js-modal-alt-close');

	function modalClose(e) {
		const box = this.querySelector('.js-modal-alt-wrap');
		const close = this.querySelector('.js-modal-alt-close');
		if (e.target !== box && e.target !== close) {
			return;
		}
		//console.log(this);
		closeBtn.forEach((item) => {
			item.removeEventListener('click', modalClose);
		});
		document.body.classList.remove('modal-open');
	}

	function modalOpen(e) {
		e.preventDefault();
		document.body.classList.add('modal-open');
		closeBtn.forEach((item) => {
			item.addEventListener('click', modalClose);
		});
		modals.forEach((item) => {
			item.addEventListener('click', modalClose);
		});
	}
	modalLinks.forEach((item) => {
		item.addEventListener('click', modalOpen);
	});
};
